import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PatchRoomPayload, RoomResponse, patchRoom } from '~/services/AccommodationService';

import { propertyRoomsQueryKeys } from './useGetPropertyRooms';

interface UpdateRoomParams {
  propertyId: string;
  roomId: string;
  data: PatchRoomPayload;
}

export function useUpdateRoom() {
  const queryClient = useQueryClient();

  return useMutation<RoomResponse, Error, UpdateRoomParams>({
    mutationFn: async ({ propertyId, roomId, data }) => {
      const response = await patchRoom({ propertyId, roomId }, data);
      return response.result;
    },
    onSuccess: (_room, variables) => {
      queryClient.invalidateQueries({ queryKey: propertyRoomsQueryKeys.detail(variables.propertyId) });
    },
  });
}
